<!-- eslint-disable vue/no-undef-properties -->
<template>
  <div :v-if="isOpen">
    <Modal :is-open="isOpen">
      <template #form>
        <h3 class="text-2xl font-medium leading-10 text-left text-gray-600 dark:text-white">
          {{ $t("Select which company owners you want to invite") }}
        </h3>
        <p class="my-2 text-gray-500 text-xsm">
          {{ $t("Please note that this list only includes users who are managing companies in your") }}
          {{ $route.params.integration_name.capitalize() }} {{ $t("instance") }}
        </p>
        <div class="w-full h-[400px] overflow-auto">
          <nav class="h-full overflow-y-auto" aria-label="Directory">
            <ul class="relative z-0 divide-y divide-gray-200 h-72">
              <li v-for="user in service_found_users" :key="user.id" class="bg-white">
                <div
                  class="relative flex items-center px-6 py-5 space-x-3 hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-light">
                  <input
                    id="send-invite"
                    v-model="user.send_invite"
                    name="send-invite"
                    type="checkbox"
                    class="w-5 h-5 border-gray-300 rounded text-blue focus:ring-blue-light">
                  <div class="flex-1 min-w-0">
                    <div class="focus:outline-none">
                      <!-- Extend touch target to entire panel -->
                      <p class="text-sm font-medium text-gray-900">
                        {{ user.first_name }} {{ user.last_name }}
                      </p>
                      <p class="text-sm text-gray-500 truncate">
                        {{ user.email }}
                      </p>
                    </div>
                  </div>
                  <div class="">
                    <Listbox v-model="user.role" as="div" class="flex-shrink-0">
                      <ListboxLabel class="sr-only">
                        {{ $t("Role") }}
                      </ListboxLabel>
                      <div class="relative">
                        <ListboxButton
                          class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 rounded-full bg-gray-50 whitespace-nowrap hover:bg-gray-100 sm:px-3">
                          <Tag
                            :class="[user.role === null ? 'text-gray-300' : 'text-gray-500', 'flex-shrink-0 h-5 w-5 sm:-ml-1']"
                            aria-hidden="true" />
                          <span :class="[user.role?.name === null ? '' : 'text-gray-900', 'hidden truncate sm:ml-2 sm:block']">{{
                            user.role?.name === null ? $t("Label") : user.role?.name
                          }}</span>
                        </ListboxButton>
                        <transition
                          leave-active-class="transition duration-100 ease-in"
                          leave-from-class="opacity-100"
                          leave-to-class="opacity-0">
                          <ListboxOptions
                            class="absolute right-0 z-10 py-3 mt-1 overflow-auto text-base bg-white rounded-lg shadow w-52 max-h-56 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            <ListboxOption
                              v-for="role in $store.state.auth.user.organization.roles"
                              :key="role.name"
                              v-slot="{ active }"
                              :value="role"
                              as="template">
                              <li :class="[active ? 'bg-gray-100' : 'bg-white', 'cursor-default relative py-2 px-3']">
                                <div class="flex items-center">
                                  <span class="block font-medium truncate">
                                    {{ role.name }}
                                  </span>
                                </div>
                              </li>
                            </ListboxOption>
                          </ListboxOptions>
                        </transition>
                      </div>
                    </Listbox>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>

        <div class="flex flex-row justify-between w-full gap-2 mt-2">
          <div
            class="w-1/2 m-0 cancel-btn"
            @click="
              () => {
                $emit('update:isOpen', false)
              }
            ">
            {{ $t("Cancel") }}
          </div>
          <button type="button" class="w-1/2 primary-btn" @click="submitInvitedUsers">{{ $t("Continue") }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Listbox, ListboxLabel, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue"
import Modal from "@/components/shared/Modal.vue"
import { Tag } from "lucide-vue-next"

export default {
  name: "DataMappingUsersInvite",
  components: {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    Modal,
    Tag
  },
  props: {
    serviceUsers: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ["submitInvitedUsers", "update:isOpen"],
  data() {
    return {
      service_found_users: []
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(val) {
        if (val) {
          this.service_found_users = this.serviceUsers
        }
      }
    }
  },
  methods: {
    submitInvitedUsers() {
      // the submitted users will have is checked true
      this.$emit("submitInvitedUsers", this.service_found_users)
    }
  }
}
</script>
